import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
var _reduceMap;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import createReducer, { objectActionHandler } from "../../../util/create_reducer";
import { PROFILE_LOAD_PROFILE, PROFILE_LOAD_PROFILE_SECTION, PROFILE_UPDATE_PROFILE, PROFILE_SAVE_PROFILE, PROFILE_SAVE_PROFILE_SECTION, PROFILE_SAVE_PROFILE_SECTION_VALUE, PROFILE_SAVE_EDUCATION_HISTORY, PROFILE_SET_OPTIONS, PROFILE_SET_ERRORS, PROFILE_SET_LOADING, PROFILE_LOAD_META, PROFILE_UPDATE_REQUIREMENT_ACTION, PROFILE_REMOVE_REQUIREMENT_FILE_ACTION, PROFILE_RETRIEVE_APPLICATIONS_ACTION, PROFILE_EDUCATION_SET_EXPANDED_ID_ACTION, PROFILE_SET_EDUCATION_HISTORY_ERRORS, PROFILE_HIGHLIGHT_ADD, PROFILE_HIGHLIGHT_REMOVE, PERSONAL_INFO_OVERLAY_TOGGLE } from "../actions/actionTypes";
export var defaultState = {
  loading: false,
  loadingSection: null,
  changedProfile: null,
  loadedProfile: null,
  educationHistory: [],
  educationHistoryErrors: {},
  options: {
    one_page: false
  },
  errors: {},
  education_expanded_id: null,
  studentProfileDocuments: [],
  highlights: [],
  personalInfoOverlay: false
};
var reducerSetLoading = function reducerSetLoading(state, action) {
  return {
    loading: action.value
  };
};
var reducerUpdateProfile = function reducerUpdateProfile(state, action) {
  return {
    changedProfile: _objectSpread(_objectSpread({}, state.changedProfile), {}, _defineProperty({}, action.value.propName, action.value.value))
  };
};
var reducerLoadProfile = function reducerLoadProfile(state, action) {
  return {
    loadedProfile: _objectSpread({
      applyboard_username: state.loadedProfile.applyboard_username
    }, action.value),
    changedProfile: _objectSpread({
      applyboard_username: state.loadedProfile.applyboard_username
    }, action.value)
  };
};
var reducerLoadMeta = function reducerLoadMeta(state, action) {
  return {
    meta: action.value
  };
};
var reducerSaveProfile = function reducerSaveProfile(state, action) {
  return {
    changedProfile: action.value
  };
};
var reducerSaveProfileSection = function reducerSaveProfileSection(state, action) {
  return {
    changedProfile: _objectSpread(_objectSpread({}, state.changedProfile), {}, _defineProperty({}, action.section, action.value))
  };
};
var reducerProfileSectionValue = function reducerProfileSectionValue(state, action) {
  return {
    changedProfile: _objectSpread(_objectSpread({}, state.changedProfile), {}, _defineProperty({}, action.section, _objectSpread(_objectSpread({}, state.changedProfile[action.section]), {}, _defineProperty({}, action.key, action.value))))
  };
};
var reducerSaveEducationHistory = function reducerSaveEducationHistory(state, action) {
  return {
    educationHistory: action.value
  };
};
var reducerSetOptions = function reducerSetOptions(state, action) {
  return {
    options: action.value
  };
};
var reducerSetErrors = function reducerSetErrors(state, action) {
  return {
    errors: action.value || {}
  };
};
var reducerLoadProfileSection = function reducerLoadProfileSection(state, action) {
  return {
    loadingSection: action.value
  };
};
var profileUpdateRequirement = function profileUpdateRequirement(state, _ref) {
  var value = _ref.value;
  return {
    changedProfile: _objectSpread(_objectSpread({}, state.changedProfile), {}, {
      documents: state.changedProfile.documents.map(function (entry) {
        return entry.id === value.id ? value : entry;
      })
    })
  };
};
var profileRemoveRequirementFile = function profileRemoveRequirementFile(state, _ref2) {
  var requirementId = _ref2.requirementId,
    fileId = _ref2.fileId;
  var requirement = state.changedProfile.documents.find(function (doc) {
    return doc.id === requirementId;
  });
  if (!requirement) {
    console.warn('cant find requirement to remove file from');
    return {};
  }
  var files = requirement.files.filter(function (entry) {
    return entry.id !== fileId;
  });
  var newRequirement = _objectSpread(_objectSpread({}, requirement), {}, {
    files: files
  });
  var documents = state.changedProfile.documents.map(function (entry) {
    return entry.id === requirementId ? newRequirement : entry;
  });
  return {
    changedProfile: _objectSpread(_objectSpread({}, state.changedProfile), {}, {
      documents: documents
    })
  };
};
var profileRetrieveApplicationsAction = function profileRetrieveApplicationsAction(state, action) {
  return {
    applications: action.value
  };
};
var profileEducationSetExpandedId = function profileEducationSetExpandedId(state, _ref3) {
  var value = _ref3.value;
  return {
    education_expanded_id: value
  };
};
var setEducationHistoryErrors = function setEducationHistoryErrors(state, _ref4) {
  var schoolId = _ref4.schoolId,
    _ref4$errors = _ref4.errors,
    errors = _ref4$errors === void 0 ? [] : _ref4$errors;
  return {
    educationHistoryErrors: _objectSpread(_objectSpread({}, state.educationHistoryErrors), {}, _defineProperty({}, schoolId, errors))
  };
};
var setProfileAddHighlight = function setProfileAddHighlight(state, _ref5) {
  var value = _ref5.value;
  if (state.highlights.indexOf(value) >= 0) return state;
  return {
    highlights: state.highlights.concat(value)
  };
};
var setProfileRemoveHighlight = function setProfileRemoveHighlight(state, _ref6) {
  var value = _ref6.value;
  if (state.highlights.indexOf(value) < 0) return state;
  return {
    highlights: state.highlights.filter(function (e) {
      return e !== value;
    })
  };
};
var setPersonalInfoOverlayToggle = function setPersonalInfoOverlayToggle(state, _ref7) {
  var value = _ref7.value;
  return {
    personalInfoOverlay: value
  };
};
var reduceMap = (_reduceMap = {}, _defineProperty(_reduceMap, PROFILE_EDUCATION_SET_EXPANDED_ID_ACTION, profileEducationSetExpandedId), _defineProperty(_reduceMap, PROFILE_HIGHLIGHT_ADD, setProfileAddHighlight), _defineProperty(_reduceMap, PROFILE_HIGHLIGHT_REMOVE, setProfileRemoveHighlight), _defineProperty(_reduceMap, PERSONAL_INFO_OVERLAY_TOGGLE, setPersonalInfoOverlayToggle), _defineProperty(_reduceMap, PROFILE_LOAD_META, reducerLoadMeta), _defineProperty(_reduceMap, PROFILE_LOAD_PROFILE, reducerLoadProfile), _defineProperty(_reduceMap, PROFILE_LOAD_PROFILE_SECTION, reducerLoadProfileSection), _defineProperty(_reduceMap, PROFILE_REMOVE_REQUIREMENT_FILE_ACTION, profileRemoveRequirementFile), _defineProperty(_reduceMap, PROFILE_RETRIEVE_APPLICATIONS_ACTION, profileRetrieveApplicationsAction), _defineProperty(_reduceMap, PROFILE_SAVE_EDUCATION_HISTORY, reducerSaveEducationHistory), _defineProperty(_reduceMap, PROFILE_SAVE_PROFILE, reducerSaveProfile), _defineProperty(_reduceMap, PROFILE_SAVE_PROFILE_SECTION, reducerSaveProfileSection), _defineProperty(_reduceMap, PROFILE_SAVE_PROFILE_SECTION_VALUE, reducerProfileSectionValue), _defineProperty(_reduceMap, PROFILE_SET_EDUCATION_HISTORY_ERRORS, setEducationHistoryErrors), _defineProperty(_reduceMap, PROFILE_SET_ERRORS, reducerSetErrors), _defineProperty(_reduceMap, PROFILE_SET_LOADING, reducerSetLoading), _defineProperty(_reduceMap, PROFILE_SET_OPTIONS, reducerSetOptions), _defineProperty(_reduceMap, PROFILE_UPDATE_PROFILE, reducerUpdateProfile), _defineProperty(_reduceMap, PROFILE_UPDATE_REQUIREMENT_ACTION, profileUpdateRequirement), _reduceMap);
var profileReducer = createReducer(defaultState, reduceMap, objectActionHandler);
export default profileReducer;